import type { CustomerContactDetailsView } from "@slfinrtl/ui-bff-routes"
import { getCustomerContactDetailsRoute } from "@slfinrtl/ui-bff-routes"
import { useCallback, useEffect, useState } from "react"
import { useCapSamlToken } from "src/hooks/cap/useCapSamlToken/useCapSamlToken"
import { useBffDynamic } from "src/hooks/useBffDynamic/useBffDynamic"

interface CustomerContactDetailsResponse {
	hasError: boolean
	value: CustomerContactDetailsView | undefined
}

export const useCustomerContactDetails = (businessPartnerId?: string): CustomerContactDetailsResponse | undefined => {
	const getCustomerContactDetails = useBffDynamic(getCustomerContactDetailsRoute, "none")
	const [customerContactDetailsResponse, setCustomerContactDetailsResponse] = useState<
		CustomerContactDetailsResponse | undefined
	>()

	const onError = useCallback(() => setCustomerContactDetailsResponse({ hasError: true, value: undefined }), [])

	const capSamlToken = useCapSamlToken(onError, Boolean(businessPartnerId))

	useEffect(() => {
		let isCancelled = false

		async function loadCustomerContactDetails() {
			setCustomerContactDetailsResponse(undefined)
			if (businessPartnerId && capSamlToken) {
				try {
					const res = await getCustomerContactDetails({
						body: undefined,
						pathParams: { businessPartnerId },
						queryParams: { capSamlToken },
					})
					if (!isCancelled) {
						setCustomerContactDetailsResponse({
							hasError: false,
							value: res,
						})
					}
				} catch {
					if (!isCancelled) {
						onError()
					}
				}
			}
		}

		void loadCustomerContactDetails()

		return () => {
			isCancelled = true
		}
	}, [businessPartnerId, getCustomerContactDetails, onError, capSamlToken])

	return customerContactDetailsResponse
}
